import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IDeleteUntimedClipsResponse } from './delete-untimed-clips-response';
import { deleteUntimedClipsResponseSchema } from './delete-untimed-clips-response';

export async function deleteUntimedClipsApi(
  collectionId: number,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IDeleteUntimedClipsResponse>> {
  return postRequest<IDeleteUntimedClipsResponse>({
    path: `/sys/pipeline/${collectionId}/delete-untimed-clips`,
    schema: deleteUntimedClipsResponseSchema,
    options,
  });
}
